<template lang="pug"> 
  v-row(justify="center" no-gutters)
    v-overlay(v-if="loading")
      vue-loading(
        type="spiningDubbles" 
        color="var(--loading-power-ball-v2)"
        :size="{ width: '100px', height: '100px' }"
      )
    .cardBackground.mt-5
        v-col(cols=12 align="center")
          v-img(:src="logoImgSrc" max-width="40%")
        v-col(cols=12)
          component(
            :is="curPage"
            :uuid="uuid"
            :mode="mode"
            :power-play="powerPlay"
            :priceStake="priceStake"
            :priceStakePowerPlay="priceStakePowerPlay"
            :closedAt="closedAt"
            :lockedAt="lockedAt"
            :load="load"
            :openedAt="openedAt"
            :rewards="rewards"
            :winNumberArray="winNumberArray"
            :cur-item-room-history="curItemRoomHistory"
            @changeMode="mode=$event"
          )
</template>
<script>
import PageGameStake from './childs/PageGameStake.vue'
import PageInfoTab from './childs/PageInfoTab'
import { powerBall as apiPowerball } from '@/apis'
import { VueLoading } from 'vue-loading-template'
import { FETCH_POWERBALL } from '@/const/setTimeOutConfig'
import { ROUTE_POWER_BALL } from '@/const/route'
const OPEN_STAKE_ID = 1
const MODE_STAKE_PANEL = 0

export default {
  components: {
    PageGameStake,
    PageInfoTab,
    VueLoading
  },
  data: () => ({ 
    loading:true,
    mode:0,
    uuid:null,
    powerPlay:null,
    priceStake:null,
    priceStakePowerPlay: null,
    closedAt:null,
    lockedAt:null,
    openedAt: null,
    roomStatus: OPEN_STAKE_ID,
    rewards: [],
    winNumberArray:[],
    curItemRoomHistory: {}
  }),
  computed: {
    curPage () {
      if(this.mode === MODE_STAKE_PANEL) {
        return 'page-game-stake'
      } else {
        return 'page-info-tab' 
      } 
    },
    logoImgSrc: () => require('@/assets/powerball/logo.svg'),
  },
  created () {
    this.load()
  },
  mounted () {
    setTimeout(()=>{
      this.loading = false
    }, 1000)
    this.updateReward()
  },
  methods: {
    async updateReward () {
      if(this.$route.name !== ROUTE_POWER_BALL) return
      setTimeout(async () => {
        const [err, data] = await apiPowerball.getRoom()
        if(err) return
        
        const room = data['room']
        if(!room) return
        this.rewards = room['rewards']
        const roomStatus = room['room_status'].id
        if(roomStatus !== OPEN_STAKE_ID) return
        this.updateReward()
      }, FETCH_POWERBALL)
    },
    async load () {
      const [err, data] = await apiPowerball.getRoom()
      if(err) return
      const winNumber =  (data['last_room'] || {})['win_number']
      if(winNumber) {
        this.winNumberArray = [...winNumber['white_ball'], winNumber["power_ball"]]
        this.powerPlay = winNumber['power_play']
      }
      const room = data['room']
      if(!room) return
      this.uuid = room['uuid']
      this.roomStatus = room['room_status'].id
      this.closedAt = room['closed_at']
      this.lockedAt = room['locked_at']
      this.openedAt = room['opened_at']
      this.rewards = room['rewards']
      this.priceStake = room['price_stake']
      this.priceStakePowerPlay = room['price_stake_power_play']

      // add to selection history
      this.curItemRoomHistory = {
        'closed_at': room['closed_at'],
        'locked_at': room['locked_at'],
        'opened_at': room['opened_at'],
        'price_stake': room['price_stake'],
        'price_stake_power_play': room['price_stake_power_play'],
        'uuid': room['uuid']
      }
    }
  }
}
</script>
<style scoped>
.cardBackground {
  padding-bottom: 150px !important;
  max-width: 1500px;
  width: 100%;
  border-radius: 16px !important;
  padding:12px;
  content: ""; 
  display: block; 
  left: 0;
  top: 0; 
  height: 100%; 
  background: url('~@/assets/powerball/bg.svg') no-repeat top center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
} 
</style>